export default __webpack_public_path__ + "static/media/phone2108.8f6cd51b.png";